import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { EChartsOption } from 'echarts';
@Component({
  selector: 'app-application-level-bar-chart',
  templateUrl: './application-level-bar-chart.component.html',
  styleUrls: ['./application-level-bar-chart.component.scss']
})
export class ApplicationLevelBarChartComponent implements OnInit, OnChanges {
  @Input() barChartData1: any;
  constructor() {
  }
  ngOnInit() {
  }
  ngOnChanges() {
    this.barChart = { ...this.barChart };
    this.barChart.xAxis['data'] = this.barChartData1.map(item => { return item['application']?.slice(0,10)+ "\n" +item['application']?.slice(10)});
    this.barChart.series['data'] = this.barChartData1.map(item => { return item['license_count'] });
    if (this.barChartData1.length == 0) {
      this.barChart.series['data'].push('no data avilable');
    }
  }

  barChart: EChartsOption = {
    tooltip: {
      trigger: 'axis'
    },
    grid: {
      left: '3%',
      right: '2%',
      bottom: '0%',
      top: '4%',
      containLabel: true
    },
    xAxis: {
      data: [],
      name: 'Modules',
      nameGap: 42,
      boundaryGap: true,
      nameLocation: 'middle',
      nameTextStyle: {
        color: "#1E3044",
        fontStyle: "normal",
        fontFamily: "am-Montserrat",
        fontWeight: "normal",
        fontSize: 12,
      },
      axisLabel: {
        // color: "#1E3044",
        fontStyle: "normal",
        fontFamily: "am-Montserrat",
        fontWeight: "normal",
        fontSize: 10,
        hideOverlap: true,
        rotate:20,
        // width:100, //fixed number of pixels
        // overflow: 'truncate', // or 'break' to continue in a new line
        // interval: 0,
        margin: 15,
      }

    },
    yAxis: {
      name: 'Count of License',
      nameLocation: 'middle',
      minInterval: 1,
      nameGap: 20,
      type: 'value',
      axisLabel: {
        // color: "#1E3044",
        fontStyle: "normal",
        fontFamily: "am-Montserrat",
        fontWeight: "normal",
        fontSize: 10,
      },
      nameTextStyle: {
        color: "#1E3044",
        fontStyle: "normal",
        fontFamily: "am-Montserrat",
        fontWeight: "normal",
        fontSize: 12,
      }

    },
    series:
    {
      barWidth: "20px",
      itemStyle: { color: "#006699" },
      data: [],
      type: 'bar'
    }

  };

}
